import { useContext } from 'react'
import { AuthContext } from '@/context/auth-context'
import { useAppDispatch } from '@/store/store-hooks'
import { AuthDialogType, openAuthDialog, setMobileSidebarOpen } from '@/store/slices/ui-state.slice'
import { isPaxtonBrand } from '@/util/enterprise'
import { Button } from '@/components/button/Button'

export default function SidebarItemAnonSignIn() {
  const dispatch = useAppDispatch()
  const isPaxtonHost = isPaxtonBrand()

  // Auth Context
  const authContext = useContext(AuthContext)
  const { user } = authContext
  const userIsAnon = user?.isAnonymous

  // Only render for anonymous users
  if (!userIsAnon) {
    return null
  }

  return (
    <div className="p-4 flex flex-row gap-3 border-t">
      {isPaxtonHost && (
        <Button
          fullWidth
          onClick={() => {
            dispatch(openAuthDialog({ authDialogType: AuthDialogType.SIGN_UP }))
            dispatch(setMobileSidebarOpen(false))
          }}
        >
          Sign up
        </Button>
      )}
      <Button
        variant="outlined"
        fullWidth
        onClick={() => {
          dispatch(openAuthDialog({ authDialogType: AuthDialogType.SIGN_IN }))
          dispatch(setMobileSidebarOpen(false))
        }}
      >
        Sign in
      </Button>
    </div>
  )
}
